// extracted by mini-css-extract-plugin
module.exports = {"container":"_6f25b66c20--container--3VC8T"};